import { Deserializable } from '../deserializable';

export class TransactionSearchRequest implements Deserializable {
  public searchTerm: string;
  public orderBy: string;
  public orderDirection: string;
  public transactionStatusId: number = 0;
  public arbFacilitatorId: number;
  public brokerId: number;
  public userId: number;
  public includeDocuments: boolean = true;
  public dateFilter: number = 5; //5=all
  public todaysTradesOnly: boolean = false;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }
}
